import { makeStyles } from '@material-ui/core/styles'

const useErrorsTableStyles = makeStyles(theme => ({
   tableContainer: {
      backgroundColor: '#FFF',
      borderTop: '4px solid #1665D8',
      padding: theme.spacing(1, 2, 0)
   },
   accordeonItemHeader: {
      backgroundColor: '#EBEFF8',
      color: '#F01E46'
   },
   errorTextContainer: {
      display: 'flex',
      padding: theme.spacing(0.5, 0)
   },
   errorIcon: {
      color: '#F01E46'
   },
   tableHeader: {
      padding: theme.spacing(1, 0, 2)
   },
   tableTitle: {
      fontWeight: 'bold'
   },
   tableBody: {
      minHeight: 240
   },
   tableFooter: {
      display: 'flex',
      justifyContent: 'flex-end'
   },
   pagination: {
      border: 0
   }
}))

export default useErrorsTableStyles
